<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row">
        <div class="buttons_section">
          <div>
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :custom-shortcuts="customShortcuts"
              color="#4b2c72"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
          <!-- <div class="pos_select_branch">
                <select class="form-control mt-2" v-model="posVendor">
                    <option disabled value="select vendor">select vendor</option>
                    <option v-for="(vendor, index) in vendors" :value="vendor" :key="index">{{ vendor }}</option> 
                </select>
            </div> -->
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="status">
              <option disabled value="selectAStatus">
                {{ $t("text.bPos.selectStatus") }}
              </option>
              <option value="">{{ $t("text.bPos.showAll") }}</option>
              <option value="00">{{ $t("text.bPos.approved") }}</option>
              <option value="0x0x0">{{ $t("text.bPos.declined") }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 pos_trans_card_holder">
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                Total Transactions
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (4).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalTransactionsAmount }}
                </h3>
                <small class="dashboard__card__header_bottom font-weight-bold">
                  {{ totalTransactions }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                Successful Transactions
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (2).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalSuccessfulTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalSuccessfulTransactions }}</small
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                Failed Transactions
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (3).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ company ? company.currencyCode : "" }}
                  {{ totalFailedTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalFailedTransactions }}</small
                >
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-md-3 remove_padding-right pos_trans_card">
              
                <div
                  class="card_container_1 pos-card mt-3"
                >
                  <p class="dashboard__card__header text-uppercase text-center">Total Cashback Charges</p>
                  <div
                    class="icon_wrapper inner_border_radius mx-auto"
                  >
                    <img src="@/assets/img/credit-card (6).svg" width="40px" />
                  </div>
                 <div class="mt-3 text-center">
                    <h3 class="font-weight-bold">{{company ? company.currencyCode : ''}} {{totalCharges}}</h3>
                  </div>
                </div>
            </div> -->
        </div>
      </div>
      <section>
        <div class="pos_table">
          <div class="row top_section_row" v-show="!showLoader">
            <div class="col-md-8">
              <span class="sec_text_color">
                POS transactions between {{ startDate }} and {{ endDate }}
              </span>
              <span> </span>
            </div>
            <div class="col-md-4 text-right"></div>
          </div>
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :toolbar="toolbar"
            :pageSettings="pageSettings"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :allowTextWrap="true"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="80"
                field="index"
                :allowSorting="false"
                headerText="#"
              ></e-column>
              <e-column
                field="paymentDate"
                :format="formatOptions"
                type="date"
                width="200"
                headerText="Transaction Date"
              ></e-column>
              <e-column
                field="branchName"
                width="180"
                headerText="Branch"
              ></e-column>
              <e-column
                field="totalTransactions"
                width="100"
                format="N2"
                headerText="Total transactions"
              ></e-column>

              <e-column
                field="successfulTransactions"
                width="150"
                format="N2"
                headerText="Successful transactions"
              ></e-column>
              <e-column
                field="failedTransactions"
                width="220"
                format="N2"
                headerText="Failed transactions"
              ></e-column>
              <!-- <e-column
                  field="retrievalReferenceNumber"
                  width="220"
                  headerText="RRN"
                ></e-column> -->
              <!-- <e-column
                  field="maskedPan"
                  width="220"
                  headerText="Masked Pan"
                ></e-column> -->
              <!-- <e-column
                  field="statusDescription"
                  width="200"
                  headerText="Status"
                ></e-column> -->
              <e-column
                width="180"
                :template="viewTemplate"
                headerText="Action"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>

        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
    <POSModal :modalData="modalData"></POSModal>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/posBank/masterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import POSModal from "@/components/modals/POS/index";
import PosTransView from "@/components/TableTemplates/posTransView";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Transactions:: Epump Portal",
  name: "POS-Transactions",
  components: {
    MasterLayout,
    TableLoader,
    POSModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branchSelected: false,
      totalCharges: 0,
      posVendor: "select vendor",
      totalChargesCount: 0,
      branches: null,
      branchId: "selectABranch",
      status: "selectAStatus",
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      terminalId: "",
      totalTransactions: 0,
      totalTransactionsAmount: 0,
      totalSuccessfulTransactions: 0,
      totalSuccessfulTransactionsAmount: 0,
      totalFailedTransactions: 0,
      totalFailedTransactionsAmount: 0,
      modalData: null,
      resultArr: [],
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: "Today", value: "day" },
        { key: "yesterday", label: "Yesterday", value: "-day" },
        { key: "last7Days", label: "Last 7 Days", value: 7 },
        { key: "lastWeek", label: "Last Week", value: "-isoWeek" },
        { key: "last30Days", label: "Last 30 Days", value: 30 },
        { key: "lastMonth", label: "Last Month", value: "-month" },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      vendors: [],
      viewTemplate: function () {
        return {
          template: PosTransView,
        };
      },
      actionTemplate: function () {
        return {
          template: Vue.component("actionButtonsTemplate", {
            template: `<div class="btn dealers_btn mr-3" @click="showDetails(data)">
                        Details
                    </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              showDetails(data) {
                this.$eventHub.$emit("showDetails", data);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("showDetails", (data) => {
      this.modalData = data;
      this.$modal.show("POSModal");
    });
    this.$eventHub.$on("PrintPos", () => {
      this.printWithCSS();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("showDetails");
  },
  mounted() {
    this.getTransactions();
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTransactions();
      }
    },
    branchId: function (newId, oldId) {
      if (newId !== null && newId !== "selectABranch") {
        this.getTransactions();
      }
    },
    status: function (newStatus, oldStatus) {
      if (newStatus !== null && newStatus !== "selectAStatus") {
        this.getTransactions();
      }
    },
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "paymentDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "POS Transactions.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    // rowDataBound: function(args) {
    //   if (args.data['statusCode'] === "00") {
    //     args.row.cells[8].style.color = "green";
    //   } else {
    //     args.row.cells[8].style.color = "red";
    //   }
    // },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getBranches() {
      const company = JSON.parse(localStorage.getItem("companyDetails"));
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${company.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          this.branches = response.data;
        })
        .catch((error) => {});
    },
    getTransactions() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      const status = this.status == "selectAStatus" ? "" : this.status;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/pos/BankTransactions?startDate=${this.startDate}&endDate=${this.endDate}&status=${status}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;
          const groupedTransactions = response.data.reduce((acc, cur) => {
            if (!acc[cur.paymentDate]) {
              acc[cur.paymentDate] = [];
            }
            if (!acc[cur.paymentDate][cur.branchName]) {
              acc[cur.paymentDate][cur.branchName] = [];
            } else {
              acc[cur.paymentDate][cur.branchName].push(cur);
            }
            return acc;
          }, {});

          const formattedTransArr = Object.keys(groupedTransactions).forEach(
            (date) => {
              const branchSummary = Object.keys(
                groupedTransactions[date]
              ).forEach((branchTrans) => {
                const totalTransactions = groupedTransactions[date][
                  branchTrans
                ].reduce((acc, cur) => (acc += cur.amount), 0);

                const totalTransactionCount =
                  groupedTransactions[date][branchTrans].length;

                const successfulTransactions = groupedTransactions[date][
                  branchTrans
                ]
                  .filter((bTrans) => bTrans.statusCode == "00")
                  .reduce((acc, cur) => (acc += cur.amount), 0);

                const successfulTransactionCount = groupedTransactions[date][
                  branchTrans
                ].filter((bTrans) => bTrans.statusCode == "00").length;

                const failedTransactions = groupedTransactions[date][
                  branchTrans
                ]
                  .filter((bTrans) => bTrans.statusCode !== "00")
                  .reduce((acc, cur) => (acc += cur.amount), 0);

                const failedTransactionCount = groupedTransactions[date][
                  branchTrans
                ].filter((bTrans) => bTrans.statusCode !== "00").length;

                const branchTransObj = {
                  paymentDate: date,
                  branchName: branchTrans,
                  totalTransactions,
                  totalTransactionCount,
                  successfulTransactionCount,
                  successfulTransactions,
                  failedTransactions,
                  failedTransactionCount,
                };

                this.resultArr.push(branchTransObj);
              });
            }
          );

          this.resultArr.forEach((el, i) => {
            el.index = i + 1;
          });

          this.totalTransactionsAmount = this.convertThousand(
            this.resultArr.reduce(
              (acc, cur) => (acc += cur.totalTransactions),
              0
            )
          );

          this.totalTransactions = this.resultArr.reduce(
            (acc, cur) => (acc += cur.totalTransactionCount),
            0
          );

          this.totalSuccessfulTransactionsAmount = this.convertThousand(
            this.resultArr.reduce(
              (acc, cur) => (acc += cur.successfulTransactions),
              0
            )
          );

          this.totalSuccessfulTransactions = this.resultArr.reduce(
            (acc, cur) => (acc += cur.successfulTransactionCount),
            0
          );

          this.totalFailedTransactionsAmount = this.convertThousand(
            this.resultArr.reduce(
              (acc, cur) => (acc += cur.failedTransactions),
              0
            )
          );

          this.totalFailedTransactions = this.resultArr.reduce(
            (acc, cur) => (acc += cur.failedTransactionCount),
            0
          );

          grid.ej2Instances.setProperties({ dataSource: this.resultArr });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style>
@media screen and (max-width: 602px) {
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 112px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
